/**
 * Convert an array of location objects to a GeoJSON FeatureCollection.
 * Preserves all fields (timestamp, altitude, stats, etc.) in each feature's properties.
 * When segments are provided, each point within a segment's time range gets a
 * `label` property with `{ activity: 'ski' | 'lift' }`.
 * @param {Array<{lat: number, lon: number, timestamp: number, [key: string]: *}>} locations
 * @param {Array<{startTime: number, endTime: number, featureType: 'run'|'lift'}>} [segments]
 * @returns {{ type: 'FeatureCollection', features: Array }}
 */
export const locationsToGeoJSONFeatureCollection = (locations, segments) => {
  if (!locations || !Array.isArray(locations)) {
    return { type: 'FeatureCollection', features: [] };
  }
  const features = locations.map((loc) => {
    const { lat, lon, ...rest } = loc;
    const properties = { ...rest };

    if (segments && segments.length > 0) {
      const ts = loc.timestamp;
      const seg = segments.find((s) => ts >= s.startTime && ts <= s.endTime);
      if (seg) {
        properties.label = {
          activity: seg.featureType === 'run' ? 'ski' : 'lift'
        };
      }
    }

    return {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [Number(lon), Number(lat)]
      },
      properties
    };
  });
  return {
    type: 'FeatureCollection',
    features
  };
};
